module.exports = __webpack_public_path__ + "assets/foralder-susanne-stockholm.29b75cc9.jpg";


//////////////////
// WEBPACK FOOTER
// ../source/assets/homepage/foralder-susanne-stockholm.jpg
// module id = 1644
// module chunks = 10